import { colors } from 'bench-style-constants';
import styled from 'styled-components';
import { rgba } from 'color-helpers';
import { iconPaths } from '../Icon';

export const SelectLayout = styled.div`
  display: grid;
  grid-template-columns: 100%;
  grid-row-gap: 4px;
`;

const sizes = {
  small: {
    buttonPadding: '3px',
    height: '24px',
  },
  medium: {
    buttonPadding: '8px',
    height: '32px',
  },
};

export const customTheme = size => reactSelectTheme => ({
  ...reactSelectTheme,
  borderRadius: '2px',
  spacing: {
    ...reactSelectTheme.spacing,
    controlHeight: sizes[size].height || size,
    menuGutter: '4px',
  },
});

export const customStyles = (iconDecoration, size, errorText) => ({
  clearIndicator: provided => ({
    ...provided,
    paddingBottom: '0',
    paddingLeft: '0',
    paddingRight: sizes[size].buttonPadding,
    paddingTop: '0',
  }),
  container: provided => ({
    ...provided,
    boxSizing: 'border-box',
    fontSize: '12px',
  }),
  control: (provided, { isFocused, isDisabled, readOnly }) => ({
    ...provided,
    background: isDisabled || readOnly ? colors.sand : colors.white,
    borderColor:
      ((isDisabled || readOnly) && colors.sand) || (errorText && colors.copper) || colors.stone,
    boxShadow:
      (errorText && `0 0 4px 1px ${colors.copper}`) ||
      (isFocused && `0 0 4px 1px ${rgba(colors.creek, 0.65)}`) ||
      'none',
    '&:hover': {
      borderColor: errorText ? colors.copper : colors.stone,
    },
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  }),
  dropdownIndicator: provided => ({
    ...provided,
    paddingBottom: '0',
    paddingLeft: '0',
    paddingRight: sizes[size].buttonPadding,
    paddingTop: '0',
  }),
  indicatorSeparator: provided => ({
    ...provided,
    display: 'none',
  }),
  menu: provided => ({
    ...provided,
    border: `1px solid ${colors.stone}`,
    borderRadius: '2px',
    boxShadow: '0 2px 6px 0 rgba(0, 0, 0, 0.15)',
    fontSize: '12px',
  }),
  option: (provided, { isDisabled, readOnly, isFocused }) => ({
    ...provided,
    backgroundColor: !isDisabled && !readOnly && isFocused ? '#DFF0F0' : null,
    color: colors.charcoal,
    lineHeight: '16px',
    paddingLeft: '11px',
  }),
  valueContainer: provided => ({
    ...provided,
    ...(iconDecoration
      ? {
          backgroundImage: `
            url('data:image/svg+xml;utf8,${encodeURIComponent(`
              <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path fill="${colors.charcoal}" d="${iconPaths[iconDecoration]}" />
              </svg>
            `)}')
          `,
          backgroundPosition: '10px 50%',
          backgroundRepeat: 'no-repeat',
          backgroundSize: '16px 16px',
          paddingLeft: '32px',
        }
      : {}),
  }),
});
